module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-Regular.52ee8b59.ttf";